import { For, Show, type Component } from 'solid-js'
import { Trans } from '@mbarzda/solid-i18next'
import type { UserTotals } from '../../../features/engagement/domain/models/engagement-users'
import { A } from '@solidjs/router'
import { Icon } from '@iconify-icon/solid'
import License from '../../../assets/icons/License'
import AwardStar from '../../../assets/icons/AwardStar'
import UserInfoCell from './custom-cells/UserInfoCell'

interface TopEngagementCardProps {
  title: string
  items: UserTotals[]
  valueSuffix?: string
  viewAllUrl?: string
}

const TopEngagementCard: Component<TopEngagementCardProps> = (props) => {
  return (
    <div class="w-full rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-base font-semibold text-gray-900">
          <Trans key={props.title} />
        </h3>
        <Show when={props.viewAllUrl}>
          {(url) => (
            <A
              href={url()}
              class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              <Trans key="ls_view_all" />
            </A>
          )}
        </Show>
      </div>
      <div class="flex flex-col">
        <For each={props.items}>
          {(item, index) => (
            <div
              class={`flex gap-4 items-center justify-between ${
                index() === props.items.length - 1 ? 'py-5 pb-0 border-none' : 'py-5 border-b border-gray-200'
              }`}
            >
              <div class="flex flex-1 min-w-0 items-center gap-3">
                <span class="w-4 text-xs font-medium text-gray-400">{index() + 1}.</span>
                <UserInfoCell user={item} />
              </div>
              <div class="flex items-center gap-4">
                <div class="flex items-center justify-center w-4 h-4">
                  {index() === 0 && (
                    <span class="text-yellow-500">
                      <Icon icon="heroicons:trophy-solid" class="text-[1.25rem]" />
                    </span>
                  )}
                  {index() === 1 && (
                    <span class="text-zinc-500">
                      <AwardStar size={5} />
                    </span>
                  )}
                  {index() === 2 && (
                    <span class="text-orange-800">
                      <License size={5} />
                    </span>
                  )}
                </div>
                <span class="text-xs font-bold text-gray-900">
                  {item.score.toLocaleString('en-US')}
                  {props.valueSuffix}
                </span>
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  )
}

export default TopEngagementCard
